import { AxiosInstance, AxiosResponse } from "axios"
import { format, parseISO } from "date-fns"

import { OriginalCalendarObject } from "./common"

export interface StagePaymentType {
  [key: string]: {
    paymentScheduleDay: number
    isDefault: number
  }
}

export interface StagePaymentServiceFeeZeroType {
  [key: string]: {
    firstPayment: number
    secondPayment: number
  }
}

export interface GetCoverageValueResponse extends AxiosResponse {
  data: {
    coverage: string
    allow_mobile_firebase_event?: boolean
    staged_payment_configuration: StagePaymentType[] | undefined
    request_region_promo_code_message: string
    fullRefundHours?: string
    fullRefundDays?: string
    id_verification?: string
    staged_payment: string | null
    staged_payment_service_fee_zero?: StagePaymentServiceFeeZeroType | undefined
    pmc_exclude_traveler_insurance?: string
    precision_pricing_beyond_days?: string
    currentRiskRatingForIdVerification?: string
    ach_payment?: string
    max_cancellation_fee?: string
    klarna_fee_percentage?: string
    klarna_fixed_fee?: string
    klarna_days?: string
  }
}

export const fillinMissingDateInCalendar = (
  tempCalendarRates: OriginalCalendarObject[],
  coverage: number,
) => {
  if (tempCalendarRates && tempCalendarRates.length >= 2) {
    const startDate = parseISO(format(new Date(), "yyyy-MM-dd"))
    let endDate = parseISO(format(new Date(), "yyyy-MM-dd"))
    endDate.setDate(endDate.getDate() + coverage)
    endDate = new Date(endDate)

    const filterData = tempCalendarRates.filter((singleDate) => {
      const rateDate = parseISO(singleDate.valid_from)

      return rateDate <= endDate && rateDate >= startDate
    })

    if (filterData.length <= coverage) {
      filterData.push({
        valid_from: format(endDate, "yyyy-MM-dd"),
        base_price: 0,
        available: false,
        min_nights: tempCalendarRates[0].min_nights,
        max_nights: tempCalendarRates[0].max_nights || 365,
        arrival: false,
        departure: true,
        weekly_arrival: false,
      })
    }
    // setup missiing date
    const missingDates = filterData
      .sort((a, b) => Date.parse(a.valid_from) - Date.parse(b.valid_from))
      .reduce(
        ((hash: { prev: number }) => {
          return function (acc: Date[], c) {
            const missingDaysNo =
              (Date.parse(c.valid_from) - hash.prev) / (1000 * 3600 * 24)
            if (hash.prev && missingDaysNo > 1) {
              for (let i = 1; i < missingDaysNo; i++)
                acc.push(
                  parseISO(
                    format(
                      new Date(hash.prev + i * (1000 * 3600 * 24)),
                      "yyyy-MM-dd",
                    ),
                  ),
                )
            }
            // eslint-disable-next-line no-param-reassign
            hash.prev = Date.parse(c.valid_from)
            return acc
          }
        })(Object.create(null) as { prev: number }),
        [],
      )

    missingDates.forEach((res) => {
      filterData.push({
        valid_from: format(res, "yyyy-MM-dd"),
        base_price: 0,
        available: false,
        min_nights: filterData[0].min_nights,
        max_nights: filterData[0].max_nights || 365,
        arrival: false,
        departure: true,
        weekly_arrival: false,
      })
    })

    filterData.sort(
      (a, b) => Date.parse(a.valid_from) - Date.parse(b.valid_from),
    )

    return filterData
  } else {
    return tempCalendarRates
  }
}

export const gettingPlaceHolderCalendar = (coverage: number) => {
  const myCurrentDate = new Date()
  const myFutureDate = new Date(myCurrentDate.getTime())
  myFutureDate.setDate(myFutureDate.getDate() + coverage)
  const returnData = [
    {
      valid_from: format(myCurrentDate, "yyyy-MM-dd"),
      base_price: 0,
      available: false,
      min_nights: 1,
      max_nights: 365,
      arrival: false,
      departure: false,
      weekly_arrival: false,
    },
    {
      valid_from: format(myFutureDate, "yyyy-MM-dd"),
      base_price: 0,
      available: false,
      min_nights: 1,
      max_nights: 365,
      arrival: false,
      departure: false,
      weekly_arrival: false,
    },
  ]
  const x = fillinMissingDateInCalendar(returnData, coverage)

  return x
}

export function getCoverageValueApi(
  axiosInstance: AxiosInstance,
): Promise<GetCoverageValueResponse> {
  const method = "get"
  const url = `/system/get-coverage`
  return axiosInstance({
    method,
    url,
  }) as Promise<GetCoverageValueResponse>
}
